/**
 * The call notice: a plain chat message the starter's Agora posts into the
 * room once the call is live. `ChatClient` sends text only (no custom Matrix
 * event type), so the notice is a message with a recognisable marker, the
 * session id at the end. Anyone can type that text, so a notice alone never
 * rings: the receiver asks the calls service whether that session is live.
 * `Stream` hides notices from the timeline; a client that does not know the
 * marker shows the readable first half.
 */
const NOTICE = /^Started a call\. agora-call:v1:([A-Za-z0-9_-]{8,128})$/;

export function callNoticeBody(sessionId: string): string {
  return `Started a call. agora-call:v1:${sessionId}`;
}

/** The session id a notice names, or `null` for any other message. */
export function parseCallNotice(body: string): string | null {
  return NOTICE.exec(body.trim())?.[1] ?? null;
}
